import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {CartIcon} from '@customink/pigment-react';

import './index.scss';

const propTypes = {
  cartItemCount: PropTypes.number
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
class ShoppingCartIcon_Lg extends PureComponent {
  static propTypes = propTypes;

  static defaultProps = {
    cartItemCount: 0
  };

  render() {
    const {cartItemCount} = this.props;
    return (
      <div className="ndx-ShoppingCartIcon_Lg">
        <CartIcon />
        {cartItemCount > 0 && (
          <div className="ndx-ShoppingCartIcon_Lg-count">{cartItemCount}</div>
        )}
      </div>
    );
  }
}

export default ShoppingCartIcon_Lg;
